import { AsiDialogView } from "@asi-ngtools/lib";
import { OnInit, Component } from "@angular/core";
import { IInstanceModeleFormulaireWebServiceClient, PaginationInstanceModeleFormulaireResultDto, RechercheInstanceModeleFormulaireDto } from "@common/resources/resources.external"
import { IConfigWebServiceClient } from "@common/resources/resources"
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";


declare var document: any;


@Component({
  selector: 'popin-completer-dossier',
  templateUrl: './popin-completer-dossier.component.html',
})
export class PopinCompleterDossierComponent extends AsiDialogView implements OnInit {

  instances: PaginationInstanceModeleFormulaireResultDto;
  public numeroDossier: string;
  index: number;
  baseExternalUrl: string[];
  instanceUrl: SafeResourceUrl;
  searchOk: boolean;
  canShow: boolean;

  constructor(private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient,
              private configWebServiceClient: IConfigWebServiceClient,
              private sanitizer:DomSanitizer) {
    super();
  }

  private async searchForInstances() {
    this.canShow = false;
    let rechercheDto = new RechercheInstanceModeleFormulaireDto();
    rechercheDto.pageIndex = 1;
    rechercheDto.nbElementsParPage = 25;
    rechercheDto.numeroDossier = this.numeroDossier;
    rechercheDto.statuts = ['EN_COURS'];
    this.instances = await this.instanceModeleFormulaireWebServiceClient.searchInstanceModeleFormulaire(rechercheDto).toPromise();
    this.searchOk = this.instances && this.instances.pagination && this.instances.pagination.results && this.instances.pagination.results.length > 0;
  }

  isPreviousAllowed() {
    return this.searchOk && this.index > 0;
  }

  isNextAllowed() {
    return this.searchOk && this.instances.pagination.results.length < (this.index+1);
  }

  previous() {
    if(this.isPreviousAllowed()) {
      --this.index;
      this.changeInstanceView();
    }
  }

  next() {
    if(this.isNextAllowed()) {
      ++this.index;
      this.changeInstanceView();
    }
  }

  async ngOnInit() {
    this.baseExternalUrl = await this.configWebServiceClient.getComplementDossierFrontUri().toPromise();
    await this.searchForInstances();
    this.index = 0;
    if(this.searchOk){
      this.changeInstanceView();
      this.canShow = true;
    }else{
      this.dialog.close();
    }
  }

  changeInstanceView() {
    this.instanceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.baseExternalUrl[0] + this.instances.pagination.results[this.index].id+"?showAriane=false");
  }

  ngAfterViewInit() {
  }

  cancel() {
      this.dialog.cancel();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/popin/popin-completer-dossier.component.ts